import api from './api';

/**
 * Ride searches students ran (last 10 days), filtered and paginated.
 * params: page, limit, user, from, to, origin, destination, timeSlot
 */
export const getSearchHistory = async (params = {}) => {
  const response = await api.get('/search-history', { params });
  return response; // Interceptor already unwraps response.data
};

/** One search with the rides it returned, in rank order. */
export const getSearch = async (id: number) => {
  const response = await api.get(`/search-history/${id}`);
  return response; // Interceptor already unwraps response.data
};
